import { LineAssociation } from '../../models/line-association.model';

export type LinesView = 'legacy' | 'all' | 'mi-parche';

export function getVisibleLines(
  lines: readonly LineAssociation[],
  view: LinesView
): LineAssociation[] {
  return view === 'mi-parche' ? lines.filter((line) => line.owner === true) : [...lines];
}
